import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IYearGroup } from "../../../Pages/Year group/IyearGroup";
import { Console } from "console";

export const AddyearGroupSlice = createSlice({
  name: "AddyearGroupSlice",
  initialState: {} as IReduxState<IYearGroup>,
  reducers: {
    addyearGroup: (state, _: PayloadAction<IYearGroup>) => {
      console.log("addyearGroup called. Current state:", state);
      
      state.isLoading = true;
    },
    successaddyearGroup: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddyearGroup: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddyearGroupResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addyearGroup,
  failureaddyearGroup,
  successaddyearGroup,
  clearAddyearGroupResponse,
} = AddyearGroupSlice.actions;

export default AddyearGroupSlice.reducer;
